import React from "react";
import ResetForm from "../Login/ResetForm";
import Header from "../shared/header/Header";
import NavigationManu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
const ResetCreative = () => {
  return (

 
    <>
      <Header />
      <NavigationManu />

      {/* <main className="auth-creative-wrapper" style={{ minHeight: "80vh",paddingTop: "40px",paddingLeft:"150px" }}> */}
<main className="nxl-container">
        <div className="nxl-content">
          <PageHeader />

          <div className="row justify-content-center mt-4">
            <div className="col-md-8 col-lg-6">
              <div className="card shadow-lg border-0 rounded-4">
                <div className="creative-card-body card-body p-sm-5">
                  <h4 className="mb-4 text-center">Reset Your Password</h4>
                  <ResetForm />
               
                </div>
                  
              </div>
             
            </div> 
          </div>

        </div> 
      </main>

   
    </>
  );
};

export default ResetCreative;
